'use client';
import { CommonImage } from '@/components/common';
import { Rating } from './components';
import { appSectionData } from './data';
import { graphics } from './images';

const AppSection = () => {
  return (
    <div className={'max-w-full bg-black'}>
      <div
        className='relative flex flex-col bg-cover object-cover object-center xl:block'
        style={{ backgroundImage: `url(${graphics})` }}
      >
        <div className='flex flex-col items-center justify-center gap-10 py-10 md:flex-row md:gap-20 md:py-20 lg:gap-40'>
          {appSectionData.apps.map((app: any, index: number) => (
            <div key={index} className='flex flex-col items-center gap-4'>
              <CommonImage
                src={app.img}
                alt={app.alt}
                loader={(option) => option.src}
                className='size-16 lg:size-24 rounded-3xl'
              />
              <Rating rating={app.rating} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppSection;
